import React from 'react';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import { useVisibleModal } from 'hooks';

import microsoftEntraIDSrc from 'assets/security/microsoft_entra_id.png';
import SecurityLabel from '../common/SecurityLabel';
import MicrosoftEntraIDModal from './MicrosoftEntraIDModal';

const MicrosoftEntraIDLabel = ({ microsoftEmail }) => {
  return (
    <SecurityLabel
      labelImageSrc={microsoftEntraIDSrc}
      labelTitle='Microsoft Email'
      detailText={microsoftEmail || 'N/A'}
    />
  );
};

const MicrosoftEntraIDControl = ({ userProfile }) => {
  const [visible, { onModal, offModal }] = useVisibleModal();

  return (
    <div>
      <Button type='primary' onClick={onModal} icon={<EditOutlined />}>
        Change Microsoft email
      </Button>
      <MicrosoftEntraIDModal
        visible={visible}
        offModal={offModal}
        userProfile={userProfile}
      />
    </div>
  );
};

const MicrosoftEntraIDStatus = () => {
  return <div />;
};

const MicrosoftEntraID = {
  Label: MicrosoftEntraIDLabel,
  Control: MicrosoftEntraIDControl,
  Status: MicrosoftEntraIDStatus,
};

export default MicrosoftEntraID;
